import config from "../../confiq/confiq";
import axiosInstance from "../../confiq/axiosInstance";

const baseURL = config.apiUrl;
const headers = config.headers;

export const fetchWebfeedSearch = async (page, pageSize, search) => {
  try {
    const endpoint = "api/webFeed/getAll";

    const response = await axiosInstance.get(
      `${endpoint}?page=${page || 1}&pageSize=${pageSize || 10}&search=${
        search || null
      }&startDate=null&endDate=null&fun=null&cat=null&brand=null`,
      {
        headers: headers,
      }
    );
    return response?.data?.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};
export const fetchStoriesSearch = async (page, pageSize, search) => {
  try {
    const endpoint = "api/story/getAll";

    const response = await axiosInstance.get(
      `${endpoint}?page=${page || 1}&pageSize=${pageSize || 10}&search=${search || null}&ind=null&fun=null&cat=null`,
      {
        headers: headers,
      }
    );
    return response?.data?.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const fetchProductSearch = async (page, pageSize, search) => {
  try {
    const endpoint = "api/products/getAll";

    const response = await axiosInstance.get(
      `${endpoint}?page=${page || 1}&pageSize=${pageSize || 10}&search=${search || null}`,
      {
        headers: headers,
      }
    );
    return response?.data?.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};
